import PontoView from '../PontoView.vue'

export const pontoRoute = [
  {
    path: '/ponto/',
    name: 'ponto',
    component: PontoView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    }
  }
]
